// Keep only type/enum exports here to avoid interfering with React Fast Refresh
export enum BadgeColor {
    Success = 'success',
    Success2 = 'success2',
    Success3 = 'success3',
    SuccessTeal = 'success-teal', // New success teal variant
    Neutral = 'neutral',
    Neutral2 = 'neutral2',
    WarningAmber = 'warning-amber', // New warning amber variant
    Warning = 'warning',
    Progress = 'progress',
    Hold = 'hold',
    Error = 'error',
    Error2 = 'error2',
    Info = 'info',
    Indigo = 'indigo',
    Violet = 'violet',
    Cyan = 'cyan',
    Pink = 'pink',
    BrandBlue = 'brandBlue', // New blue badge variants
    InfoBlue = 'infoBlue',
    SkyBlue = 'skyBlue',
    NavyBlue = 'navyBlue',
    TopPickYellow = 'topPickYellow', // New Top Pick yellow variant
}
